module.exports = __webpack_public_path__ + "img/10.da3c4078.jpg";